import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { POST_SUBJECT_AMENDMENT_PAYMENT_LINK_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: void, uuid: string) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  onSettled?: () => void;
}

export const usePostSubjectAmendmentPaymentLink = ({ onSuccess, onError, onSettled }: Input) => {
  const postSubjectAmendmentPaymentLink = async (uuid: string) => {
    await axiosClient.post(POST_SUBJECT_AMENDMENT_PAYMENT_LINK_URL(uuid));
  };

  return useCustomMutation(postSubjectAmendmentPaymentLink, {
    onSuccess,
    onError,
    onSettled,
  });
};
